import { Tag } from "antd";
import styled from "styled-components";

export const FileCard =  styled(Tag)`
  cursor: pointer;
`;